import React, { useState, Suspense, useEffect } from "react";
import CustomSingleSelect from "../../../common/custom-single-select/custom-single-select";
import "./dashboard-filters.css";

import { useNavigate, useLocation } from "react-router-dom";

const DashboardFilters = () => {
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState("");
  const navigate = useNavigate();
  const handleOnChangeDropDownFilter = (value) => {
    setSelectedValue(value);
    switch (value) {
      case "Home":
        navigate("/dashboard");
        break;
      case "Question Based Graph":
        navigate("/question-based-graph");
        break;
      case "Upload CSV":
        navigate("/upload-csv");
        break;

      case "Select Database":
        navigate("/select-database");
        break;
    }
  };

  useEffect(() => {
    switch (location.pathname) {
      case "/dashboard":
        setSelectedValue("Real-Time-Dashboard");
        break;
      case "/question-based-graph":
        setSelectedValue("Question Based Graph");
        break;
      case "/upload-csv":
        setSelectedValue("Upload CSV");
        break;

      case "/select-database":
        setSelectedValue("Select Database");
        break;
    }
  }, [location]);
  return (
    <div className="filter-main-div">
      <div style={{ width: "200px" }}>
        <Suspense>
          <CustomSingleSelect
            items={[
              { id: 1, value: "Home" },
              { id: 3, value: "Upload CSV" },
            ]}
            onChange={handleOnChangeDropDownFilter}
            value={selectedValue}
          ></CustomSingleSelect>
        </Suspense>
      </div>
      {/* <div className="row-count">
        <b>
          Total Rows <br></br>
          <span style={{ color: "#E00173" }}>34543</span>
        </b>
      </div> */}
    </div>
  );
};
export default DashboardFilters;
